module.exports = "https://r.nearpod.com/assets/media/image/youtube-icon-fa48c8eeca0e393fb0f63e9499cd31dc.svg";